// src/components/preview/PracticeMatchDrawer.tsx
import React from "react";

export default function PracticeMatchDrawer({
  top,
}: {
  top: {
    boardId: string;
    boardTitle: string;
    triggerText: string;
    stage: "strict" | "substring" | "tail" | "anchor" | "fuzzy" | "semantic";
    latencyMs: number;
  } | null;
}) {
  return (
    <div className="card" aria-live="polite">
      <div className="label" style={{ marginBottom: 6 }}>Practice Results</div>
      {!top ? (
        <div className="muted small">No match yet. Try speaking a natural interview question.</div>
      ) : (
        <div className="vstack-sm">
          <div style={{ fontWeight: 700 }}>{top.boardTitle}</div>
          <div className="small muted">Matched trigger: <span className="practice-trigger">{top.triggerText}</span></div>
          <div className="small muted">Stage: <b>{stageLabel(top.stage)}</b> • Matcher: <b>{top.latencyMs}ms</b></div>
          <div className="small muted">Preview-only — mic here never triggers cues in Live.</div>
        </div>
      )}
    </div>
  );
}

function stageLabel(s: string) {
  switch (s) {
    case "strict": return "Strict";
    case "substring": return "Substring";
    case "tail": return "Tail";
    case "anchor": return "Anchor";
    case "fuzzy": return "Fuzzy";
    case "semantic": return "Semantic";
    default: return s;
  }
}
